<template>
  <div class="flex flex-row w-full justify-content-between">
    <Button
      label="Previsualizar"
      icon="pi pi-eye"
      severity="secondary"
      @click="$emit('onPreview')"
    ></Button>
    <div class="flex flex-row">
      <InfoButton
        :message="`Por favor, suba imágenes en formato JPG o PNG con una resolución adecuada para garantizar una visualización óptima en el documento.
                         Asegúrese de que la imagen no contenga contenido sensible o inapropiado.`"
      />
      <FileUpload
        ref="headerUploadRef"
        mode="basic"
        class="ml-3 text-center text-md font-light mr-2"
        custom-upload
        @uploader="removeHeaderImg"
        @select="saveHeaderImg($event)"
        :chooseLabel="'Imagen de encabezado'"
        severity="secondary"
        accept="image/*"
        style="background: #f9f9f9; border: #e4e4e4; color: gray"
      />
      <FileUpload
        ref="footerUploadRef"
        mode="basic"
        class="text-center text-md font-light mr-2"
        custom-upload
        @uploader="removeFooterImg"
        @select="saveFooterImg($event)"
        :chooseLabel="'Imagen de Pie de página'"
        severity="secondary"
        accept="image/*"
        style="background: #f9f9f9; border: #e4e4e4; color: gray"
      />
      <Divider layout="vertical" />
      <!-- </div> -->
      <Button
        label="Guardar"
        icon="pi pi-save"
        class="p-button-text text-md font-light"
        @click="$emit('saveEditorContent')"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
  import { nextTick, onMounted, ref } from 'vue'
  import InfoButton from '@/shared/components/InfoButton.vue'
  const footerImg = ref()
  const headerImg = ref()
  const footerName = ref()
  const headerName = ref()

  const headerFile = ref<File | null>(null)
  const footerFile = ref<File | null>(null)

  // Refs to access FileUpload components
  const headerUploadRef = ref()
  const footerUploadRef = ref()

  onMounted(async () => {
    headerImg.value = props.headerImg
    footerImg.value = props.footerImg
    if (props.headerImg) {
      headerFile.value = getFileFromImgTag(props.headerImg)
      headerName.value = getFileNameFromImgTag(props.headerImg)
      headerFile.value &&
        (await prefillFileUpload(headerUploadRef, headerFile.value))
    }
    if (props.footerImg) {
      footerFile.value = getFileFromImgTag(props.footerImg)
      footerName.value = getFileNameFromImgTag(props.footerImg)
      footerFile.value &&
        (await prefillFileUpload(footerUploadRef, footerFile.value))
    }
  })

  const prefillFileUpload = async (uploadRef: any, file: File) => {
    await nextTick()
    if (uploadRef.value) {
      uploadRef.value.files = [file]
    }
  }

  const props = defineProps<{
    headerImg?: string
    footerImg?: string
  }>()

  const saveHeaderImg = (event: any) => {
    const file = event.files[0]
    if (!file) return

    headerFile.value = file // Store file reference
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      headerImg.value = `
            <div style="width: 100%; position: absolute; top: 0; left: 0; margin: 0; padding: 0;">
                <img src="${reader.result}" 
                    alt="${file.name}" 
                    style="width: 100%; height: auto; margin: 0; padding: 0; display: block;"/>
            </div>
        `
      headerName.value = file.name
    }
  }

  const saveFooterImg = (event: any) => {
    const file = event.files[0]
    if (!file) return

    footerFile.value = file // Store file reference
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      footerImg.value = `
            <div style="width: 100%; position: absolute;  bottom:0; left:0; margin: 0; padding: 0;">
               <img src="${reader.result}" 
                    alt="${file.name}" 
                    style="width: 100%; height: auto; margin: 0; padding: 0; display: block;"/>
             </div>
        `
      footerName.value = file.name
    }
  }

  const getFileNameFromImgTag = (tag: string): string | null => {
    const match = tag.match(/alt="([^"]*)"/)
    return match ? match[1] : null
  }

  const getFileFromImgTag = (tag: string) => {
    const match = tag.match(/src="([^"]*)"/)
    const blob = match ? new Blob([match[1]]) : undefined
    if (!blob) return null
    return new File([blob], getFileNameFromImgTag(tag) || 'unknow name', {
      type: blob.type,
    })
  }

  const removeHeaderImg = () => {
    headerImg.value = undefined
    headerFile.value = null
    headerName.value = 'Imagen de encabezado'
  }

  const removeFooterImg = () => {
    footerImg.value = undefined
    footerFile.value = null
    footerName.value = 'Imagen de pie de pagina'
  }

  const emit = defineEmits<{
    (event: 'saveEditorContent'): void
    (event: 'onPreview'): void
  }>()

  defineExpose({
    headerImg,
    footerImg,
  })
</script>
